import { createSlice } from "@reduxjs/toolkit";
import {getWalk} from '../reduxApi/walkThroughReduxApi'

const walkSlice = createSlice({
    name: 'walkthrough',
    initialState: {
        status: 'idel',
        isFiltered: false,
        walkthrough: [],
    },
    reducers: {
          setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteWalkAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.walkthrough.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.walkthrough.splice(index, 1);
                }
            });
        },
        updateWalkAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.walkthrough.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.walkthrough.splice(index, 1, action.payload )
            }
        },
        addWalkAction: (state, action) => {
            console.log("Adding walkthrough:", action.payload);
            // state.walkthrough.unshift( action.payload.formData );
            const temp = action.payload.formData;
            console.log("Temporary walkthrough data:", temp);
            temp.ROWID = action.payload.ROWID;
            state.walkthrough.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getWalk.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getWalk.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                // console.log("testing walkthrough Data", action.payload)
                state.walkthrough = action.payload.data.walkthroughs;
            })
    }
})
export const { deleteWalkAction, updateWalkAction, addWalkAction,setFilteredStatus } = walkSlice.actions
export default walkSlice.reducer